import * as React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { buttonStyles } from './style';
import { classNames } from '../../../utils/classNames';

interface ButtonUIProps {
  onClickHandler: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined;
  className?: string;
  text?: string;
  icon?: React.ReactNode;
  variant?: 'text' | 'contained' | 'outlined' | undefined;
  type?: 'primary' | 'secondary' | 'input' | 'modalPrimary' | 'modalSecondary' | 'modalText';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  fullWidth?: boolean;
  autoFocus?: boolean;
  dataTestId?: string;
}
export default function ButtonUI(props: ButtonUIProps): JSX.Element {
  const {
    onClickHandler,
    text,
    icon,
    variant = 'contained',
    type,
    size = 'small',
    disabled,
    endIcon,
    startIcon,
    className,
    fullWidth = false,
    autoFocus = false,
    dataTestId,
  } = props;
  const { button } = buttonStyles;

  const mods = {
    primaryBtn: type === 'primary',
    secondaryBtn: type === 'secondary',
    inputBtn: type === 'input',
    modalPrimaryBtn: type === 'modalPrimary',
    modalSecondaryBtn: type === 'modalSecondary',
    modalTextBtn: type === 'modalText',
  };

  return (
    <>
      {!icon ? (
        <Button
          className={classNames('', mods, [className])}
          onClick={onClickHandler}
          variant={variant}
          sx={button}
          disabled={disabled}
          endIcon={endIcon}
          startIcon={startIcon}
          size={size}
          fullWidth={fullWidth}
          autoFocus={autoFocus}
          data-testid={dataTestId}
        >
          {text}
        </Button>
      ) : (
        <IconButton
          className={classNames('', {}, [className])}
          aria-label="play-stop"
          size={size}
          onClick={onClickHandler}
          disabled={disabled}
        >
          {icon}
        </IconButton>
      )}
    </>
  );
}
